import { NgStyle } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-icon-cross-eye",
  standalone: true,
  host: {
    "[style.width]": "size()",
    "[style.height]": "size()",
    "style.display": "inline-flex",
    "style.align-items": "center",
    "style.justify-content": "center",
  },
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 24 24"
      fill="none"
      [ngStyle]="{ color: color() }"
    >
      <path
        d="M4.92893 9C3.11929 10.5 2 12 2 12C2 12 6.47715 18 12 18C12.6849 18 13.3538 17.9077 14 17.746M10.0159 6.25C10.6572 6.0908 11.3207 6 12 6C17.5229 6 22 12 22 12C22 12 20.8807 13.5 19.0711 15"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.1571 10.3105C9.74905 10.7554 9.5 11.3486 9.5 11.9999C9.5 13.3806 10.6193 14.4999 12 14.4999C12.6813 14.4999 13.2991 14.2273 13.75 13.7852"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 21L3 3"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,

  imports: [NgStyle],
})
export class IconCrossEyeComponent {
  public readonly color = input("black");
  public readonly size = input("24px");
}
